import * as MyKeysApi from './index';
import * as Register from '../../../modules/dialogs/register';
import * as Devices from '../../../modules/devices';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

export const registerDevices = (
  devices: Register.RegisterDevice[]
): Promise<any> => {
  const body = {
    devices: devices.map((d: Register.RegisterDevice) => ({
      manufactureId: d.manufactureId,
      serialNumber: d.serialNumber,
      deviceCode: d.code,
    })),
  };
  Logger.info(['POST: Device Register Requested', body], LogArea.Api);
  return MyKeysApi.post('devices/register', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};

export const validateDevice = (device: Devices.PKey): Promise<any> => {
  const body = {
    manufactureId: device.manufactureId,
    serialNumber: device.serialNumber,
  };
  Logger.info(['POST: Device Validation Requested', body], LogArea.Api);
  return MyKeysApi.post('devices/register/validation', body, true)
    .then((res) => res.data)
    .catch(MyKeysApi.parseError);
};
